import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import placeholder from '@/assets/placeholder.svg';
import BrandingHeader from '@/components/BrandingHeader';
import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';
import { getBrandingLogoUrl } from '@/utils/logo';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const LoginLayout = () => {
  const { isMobile } = usePlatform();
  const { experienceSettings, theme } = useContext(PageContext);

  if (!experienceSettings) {
    return null;
  }

  const {
    color: { isDarkModeEnabled },
    branding,
  } = experienceSettings;

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.root)}>
        <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
          {/* <div className={styles.brandingLogo}>OK</div> */}
          <BrandingHeader
            className={classNames(styles.brandingLogo, layoutClassNames.brandingHeader)}
            logo={getBrandingLogoUrl({ theme, branding, isDarkModeEnabled })}
            // thirdPartyLogo={getBrandingLogoUrl({ theme, branding: thirdPartyBranding, isDarkModeEnabled })}
          />
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
            {/* <LogtoSignature className={classNames(styles.signature, layoutClassNames.signature)} /> */}
          </main>
        </div>
        <div className={classNames(styles.branding, 'logto_branding_container')}>
          <img src={placeholder} alt="placeholder" className={styles.placeholderImage} />
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;
